import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactTable from "react-table";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Button } from "components";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import "../../assets/css/react-table.css";
import { withTranslation } from 'react-i18next';


const CheckboxTable = checkboxHOC(ReactTable);


class ArchiveChooser extends Component {

  constructor(props) {
    super(props);

    const { selectedArchiveId } = props;

    this.state = {
      selection: selectedArchiveId,
      selectAll: false
    }

    

  }

  toggleSelection = (key) => {
    this.setState({ selection: key });
  };

  isSelected = key => {
    return this.state.selection == key;
  };


  render() {

    const { t, onConfirm, onCancel, instances, archive, title, model } = this.props;
    const { toggleSelection, isSelected } = this;
    const { selection } = this.state;

    let data = [];

    if (instances) {
      data = instances.map((instance, key) => {
        return {
          _id: instance.id,
          index: instance.id,
          ...instance
        }
      });
    }

    const columns = model.map((column)=>{
      return {
        Header: column.label,
        accessor: column.field,
        filterable: true
      }
    });

    const checkboxProps = {

      isSelected,
      toggleSelection,
      selectType: "radio",
      getTrProps: (s, r) => {
        const selected = (typeof r != 'undefined') && this.isSelected(r.original._id);
        return {
          onClick: (e) => {
            toggleSelection(r.original._id);
            //onConfirm(r.original._id);
          },
          // onDblClick: (e) => {
          // },

          style: {
            backgroundColor: selected ? "#FFFACD" : "inherit"
          }
        };
      }
    };


    return (

      <Modal isOpen={true} className="modal-notice modal-lg"  >
        <ModalHeader
          className="title-up"
        >
          { t(title) }
        </ModalHeader>
        <ModalBody>

          <CheckboxTable
            ref={r => (this.checkboxTable = r)}
            data={data}
            className="-striped -highlight"
            previousText={t('Precedente')}
            nextText={t('Successiva')}
            noDataText={t('Nessun record')}
            pageText={t('Pagina')}
            ofText={t('di')}
            rowsText={t('righe')}
            columns={columns}
            defaultPageSize={10}
            className="-striped -highlight"
            {...checkboxProps}
          />

        </ModalBody>

        <ModalFooter className="justify-content-center">

          <Button
            color="danger"
            round
            onClick={(e) => { onCancel(); }}
          >
            {t("Annulla")}
          </Button>
          &nbsp;
          <Button
            color="info"
            round
            onClick={(e) => { onConfirm(selection); }}
          >
            OK
          </Button>

        </ModalFooter>
      </Modal>


    );

  }
}

export default ArchiveChooser=withTranslation()(ArchiveChooser);


// WEBPACK FOOTER //
// ./src/views/Navigator/ArchiveChooser.jsx